<template>
  <div class="outer-container">
    <div class="line-spacing big-text rich-text-editor-custom-css" v-html="optionalQuestion" />
    <div class="line-spacing big-text">
      <textarea style="border: 1px solid black;" v-model="answer" rows="4" cols="40"></textarea>
    </div>
    <div class="line-spacing">
      <button class="pure-button bigmi-red-2-button" v-on:click="submit">{{ $t('next') }}</button>
    </div>
  </div>
</template>

<script>
import { GET_BACKEND_URL, USER_POSITION_IN_SURVEY, COMPLETE_SURVEY } from "../../services/constants"
import http from "../../services/axios"

export default {
  name: 'SurveyPreQuestion',

  data () {
    return {
      answer: '',
    }
  },

  methods: {
    submit () {
      if (this.$store.state.surveyModule.isSurveyPreview) {
        this.$store.dispatch(USER_POSITION_IN_SURVEY, { sendToPreQuestion: false })
      } else {
        let answerPayload = { 'optionalPreQuestionAnswer': this.answer }
        let studyID = this.$store.state.surveyModule.survey.data.study.id
        let uniqueIdentifier = this.$route.params.survey_id
        http.post(this.$store.getters[GET_BACKEND_URL](`studies/${studyID}/participants/${uniqueIdentifier}/optional-pre-question`), answerPayload).then(response => {
          this.$store.dispatch(USER_POSITION_IN_SURVEY, { sendToPreQuestion: false })
        }).catch(err => {
          console.error(err)
        })
      }
    },
  },
  computed: {
    optionalQuestion () {
      return this.$store.state.surveyModule.survey.data.study.optionalPreQuestion
    },
  }
}
</script>

<style scoped lang="scss">
@import "../../scss/main";

.outer-container {
  padding: 5%;
  max-width: 1024px;
  @media #{$mobile} {
    width: 80%;
  }
}

.header {
  padding-top: 10%;
  padding-bottom: 5%;
  color: $red-2;
  font-weight: bold;
  font-size: 17px;
}

.big-text {
  font-size: 17px;
}

.small-text {
  font-size: 13px;
}

.button {
  border-color: $red-2;
  font-weight: bold;
  background-color: $white-1;
  border-width: medium;
  color: $red-2;
  border-radius: 3px;
  padding: 10px 20px;
}

.line-spacing {
  padding-top: 5%;
  padding-bottom: 5%;
}
</style>
